/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type DriveOnReportDtoStatus = typeof DriveOnReportDtoStatus[keyof typeof DriveOnReportDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriveOnReportDtoStatus = {
  SUCCESS: 'SUCCESS',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
} as const;
